<template>
  <div style="display: flex;position: relative;">
    <b-calendar :mark="markList" @changeDate="getDate" @openDetail="getDetail"></b-calendar>
    <div style=" margin: 20px; border: 1px solid #ccc;" class="date-range" v-if="displayPanel">
      <div style="color: #000;font-size: 16px;font-weight: 700;font-family: blod;margin-bottom: 20px;" class="title">{{currentDate}}分时段预约情况：</div>
      <div v-if="morningList.length > 0">
        <div style="color: #000;font-size: 14px;font-weight: 700;margin-bottom: 10px;">上午:</div>
        <div class="content">
          <div :class="['item']" v-for="(item, index) in morningList" :key="index">
            <div class="text">{{item.text}}</div>
            <div :class="['count', { 'item-close': item.state === 0, 'item-full': item.numberOfAvailableReservation === item.numberOfReservation && item.state !== 0 , 'item-unfull': item.numberOfAvailableReservation !== item.numberOfReservation && item.numberOfReservation && item.state !== 0}]"><span v-if="item.state !== 0">{{item.count}}人</span></div>
          </div>
        </div>
      </div>
      <div v-if="afternoonList.length > 0">
        <div style="color: #000;font-size: 14px;font-weight: 700;margin-bottom: 10px;">下午</div>
        <div class="content">
          <div :class="['item']" v-for="(item, index) in afternoonList" :key="index">
            <div class="text">{{item.text}}</div>
            <div :class="['count', { 'item-close': item.state === 0, 'item-full': item.numberOfAvailableReservation === item.numberOfReservation && item.state !== 0, 'item-unfull': item.numberOfAvailableReservation !== item.numberOfReservation && item.numberOfReservation && item.state !== 0}]">{{item.count}}人</div>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;align-items: flex-end;margin-bottom: 22px;" class="lengend">
      <span class="item-close">关闭预约</span>
      <span class="item-unfull">未约满</span>
      <span class="item-full">已约满</span>
    </div>
  </div>
</template>
<script>
import BCalendar from './Calendar.vue'
export default {
  components: {
    BCalendar
  },
  props: {
    collectPointId: {
      type: String
    }
  },
  mounted () {
    this.initYearAndMonth()
    this.initReservationInfo()
    this.getTimeRangeInfo()
  },
  watch: {
    collectPointId () {
      this.initReservationInfo()
      this.getTimeRangeInfo()
      this.displayPanel = false
    }
  },
  data () {
    return {
      displayPanel: false,
      // collectPointId: '18b44bceb5e49000',
      yearAndMonth: null,
      currentDate: null,
      markList: {},
      morningList: [],
      afternoonList: [],
      infoList: [],
      range: []
    }
  },
  methods: {
    initYearAndMonth () {
      const date = new Date()
      this.yearAndMonth = `${date.getFullYear()}-${(date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))}`
    },
    async getTimeRangeInfo () {
      this.range = []
      const timeResult = await this.$$api.bis.get(`/dic/getTimeRange?collectPointId=${this.collectPointId}`)
      const timeData = timeResult.data || []
      timeData.map(t => {
        this.range.push({
          value: t.id,
          text: t.text,
          numberOfAvailableReservation: t.numberOfAvailableReservation,
          timeCategory: JSON.parse(t.data).timeCategory
        })
      })
    },
    // 根据采血点和当前日期获取当天预约详情
    async getOrderDetail () {
      this.infoList = []
      if (!this.collectPointId || !this.currentDate) {
        return
      }
      const range = JSON.parse(JSON.stringify(this.range))
      const orderDetail = await this.$$api.bis.get(`reservation/getByLocationId?locationId=${this.collectPointId}&reservationDate=${this.currentDate}`)
      const detail = orderDetail.data
      range.map(r => {
        const info = detail.filter(v => v.timeRangeId === r.value)
        if (info.length > 1) {
          const findItem = info.find(i => i.availableDayStart || i.availableDayEnd)
          if (findItem) {
            r.state = findItem.state
            r.numberOfAvailableReservation = findItem.numberOfAvailableReservation
            r.numberOfReservation = findItem.numberOfReservation
            r.count = r.numberOfAvailableReservation - r.numberOfReservation
          }
        } else {
          r.state = info[0]?.state
          r.numberOfAvailableReservation = info[0]?.numberOfAvailableReservation
          r.numberOfReservation = info[0]?.numberOfReservation
          r.count = r.numberOfAvailableReservation - r.numberOfReservation
        }
      })
      this.infoList = range
      this.morningList = this.infoList.filter(i => i.timeCategory === 1)
      this.afternoonList = this.infoList.filter(i => i.timeCategory === 2)
    },
    getDate (v) {
      this.yearAndMonth = v
      this.initReservationInfo()
    },
    getDetail (date) {
      this.displayPanel = true
      this.currentDate = date
      this.getOrderDetail()
    },
    async initReservationInfo () {
      this.markList = {}
      const result = await this.$$api.bis.get(`reservation/reservationDetails?collectPointId=${this.collectPointId}&yearAndMonth=${this.yearAndMonth}`)
      const local = result.data?.local || {} // 关闭信息
      const global = result.data?.global || [] // 预约人数信息
      // 关闭信息处理 local中会返回当月含关闭时间段的所有date, 此处需要根据全局时间段判断是否所有时间段都关闭，如果都关闭则展示关闭预约，如果部分关闭则要展示红点标记和预约人数
      const closeDetail = {}
      for (const key in local) {
        const closeObj = {
          allClose: false
        }
        const closeArr = local[key].filter(l => l.state === 0)
        if (closeArr.length === global.length) {
          closeObj.allClose = true
        }
        closeDetail[key] = closeObj
      }
      // 预约人数处理 global中会返回各时间段有预约人数的日期，根据时间段整合预约人数
      const reservationDetail = {}
      // 获取所有时间段总的可预约人数
      let totalNumberOfAvailable = null
      global.map(g => {
        totalNumberOfAvailable += g.numberOfAvailableReservation
        if (g.reservationDetails) {
          for (const key in g.reservationDetails) {
            if (Object.hasOwnProperty.call(reservationDetail, key)) {
              reservationDetail[key].numberOfReservation += g.reservationDetails[key].numberOfReservation
            } else {
              reservationDetail[key] = Object.assign({}, g.reservationDetails[key], { numberOfAvailableReservation: g.numberOfAvailableReservation })
            }
          }
        }
      })
      // 通过已预约信息和关闭信息整合最后的markList
      Object.keys(reservationDetail).map(r => {
        reservationDetail[r].numberOfAvailableReservation = totalNumberOfAvailable
        // 减去关闭时间段的人数
        if (Object.hasOwnProperty.call(local, r)) {
          const timeArr = local[r]
          timeArr.map(t => {
            if (t.state === 0) {
              const count = global.find(g => g.timeRangeId === t.timeRangeId).numberOfAvailableReservation || 0
              reservationDetail[r].numberOfAvailableReservation = reservationDetail[r].numberOfAvailableReservation - count
            }
          })
        }
        if (reservationDetail[r].numberOfReservation < reservationDetail[r].numberOfAvailableReservation) {
          reservationDetail[r].markType = 2
        } else {
          reservationDetail[r].markType = 1
        }
        reservationDetail[r].number = reservationDetail[r].numberOfReservation
        if (Object.hasOwnProperty.call(closeDetail, r)) {
          if (closeDetail[r].allClose) {
            reservationDetail[r].markType = 3
          } else {
            reservationDetail[r].needRed = true
          }
        }
      })
      Object.keys(closeDetail).map(c => {
        if (!Object.hasOwnProperty.call(reservationDetail, c)) {
          const obj = {
            markType: closeDetail[c].allClose ? 3 : 2,
            number: 0,
            needRed: true
          }
          reservationDetail[c] = obj
        }
      })
      if (Object.keys(reservationDetail).length > 0) {
        Object.keys(reservationDetail).map(d => {
          const key = Number(d.split('-')[2])
          this.$set(this.markList, key, reservationDetail[d])
          // this.markList[key] = reservationDetail[d]
        })
      } else {
        this.markList = {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.date-range {
  box-shadow: 0 0 0.52vw 0 rgba(0, 0, 0, 0.2);
  padding: 20px;
  width: 450px;
  background-color: #fff;
}
.item-close {
  background-color: #F76361;
  color: #fff
}
.item-full {
  color: #fff;
  background-color: rgb(64,149,229);
}
.item-unfull {
  color: #fff;
  background-color: rgb(129,179,55);
}
.content {
  width: 420px;
  display: flex;
  flex-wrap: wrap;
}
.item {
  margin-bottom: 10px;
  font-family: blod;
  color: #000;
  font-size: 14px;
  width: 25%;
  text-align: center;
  border: 1px solid #eee;
  margin-right: -1px;
  .text {
    padding: 10px 10px;
    border-bottom: 1px solid #eee;
  }
  .count {
    height: 40px;
    line-height: 40px;
  }
}
.lengend {
  font-family: blod;
  font-size: 14px;
  span {
    padding: 3px 5px;
    margin-left: 10px;
    color: #fff
  }
}
</style>
